import React from 'react';
import "./layout.css"
import { BrowserRouter as Router} from 'react-router-dom'

import { Row, Col } from 'react-bootstrap';

// components
import Footer from '../components/Footer'
import TopBar from '../components/TopBar'
import SideBar from '../components/SideBar';

const Layout = ({ children }) => {
  return (
    <Router>
        <div className="body-content">
        <TopBar />
        <div class="row" id="body-row">
          <SideBar />
            <div class="col py-3">
              {children}
            </div>
        </div>
        <Footer />
      </div>
    </Router>
  )
}

export default Layout
